import {
  Activity,
  AlarmClock,
  Bookmark,
  ArrowLeft,
  ArrowRightLeft,
  AtSign,
  Ban,
  Bell,
  BellOff,
  Building2,
  CalendarClock,
  CalendarDays,
  Check,
  CheckCircle2,
  CircleDashed,
  CircleHelp,
  Crown,
  Eye,
  Flag,
  FlagOff,
  Flame,
  Folder,
  FolderOpen,
  FolderTree,
  Gauge,
  GitBranch,
  History,
  Inbox,
  IterationCw,
  Key,
  KeyRound,
  LogIn,
  Mail,
  Layers,
  LayoutTemplate,
  Link2,
  OctagonPause,
  ListOrdered,
  ListTodo,
  Lock,
  LockOpen,
  MessageSquare,
  MessageSquareText,
  Network,
  MessagesSquare,
  Paperclip,
  Pencil,
  Phone,
  Pin,
  Plus,
  RefreshCw,
  RotateCcw,
  Settings,
  Shield,
  ShieldCheck,
  SignalHigh,
  Siren,
  Sparkles,
  Stamp,
  StickyNote,
  Star,
  Tag,
  Timer,
  Trash2,
  Trophy,
  Unlink,
  Upload,
  UserCheck,
  UserCog,
  UserMinus,
  UserPlus,
  UserRound,
  Users,
  UserStar,
  Wrench,
  XCircle,
  type LucideIcon,
  Bug,
  BookOpen,
  CircleDot,
  Shapes,
  Library,
  Megaphone,
  MessageSquareWarning,
  Newspaper,
  Mailbox,
} from 'lucide-react';


export const TicketIcon = Inbox;
export const SprintIcon = CalendarClock;
export const DateIcon = CalendarDays;
export const TaskIcon = ListTodo;
export const BacklogIcon = ListOrdered;
export const BoardViewIcon = Bookmark;
export const TaskLabelIcon = Tag;
export const TaskHoursIcon = Timer;
export const TaskPriorityIcon = SignalHigh;
export const CriticalPriorityIcon = Flame;
export const TaskLinkIcon = Link2;
export const BlockedIcon = OctagonPause;
export const CapacityIcon = Gauge;
export const PlanFrozenIcon = Lock;
export const PlanOpenIcon = LockOpen;
export const PlanPinIcon = Pin;
export const CarryOverIcon = IterationCw;
export const ChatIcon = MessageSquare;
export const NoteIcon = StickyNote;
export const JournalIcon = History;
export const MessengerIcon = MessagesSquare;
export const ApprovalIcon = Stamp;
export const MassIncidentIcon = Siren;
export const GroupIcon = Wrench;
export const LeadIcon = Crown;
export const ParticipantsIcon = Users;
export const PersonIcon = UserRound;
export const EmailIcon = Mail;
export const PhoneIcon = Phone;
export const SignInIcon = LogIn;
export const ClientIcon = Building2;
export const DepartmentIcon = Network;
export const CategoryIcon = FolderOpen;
export const ServiceIcon = Shapes;
export const CatalogIcon = Layers;
export const FolderIcon = Folder;
export const FolderTreeIcon = FolderTree;
export const FolderGrantIcon = KeyRound;
export const ApiKeyIcon = Key;
export const SlaIcon = Timer;
export const KpiIcon = Trophy;
export const RatingIcon = Star;
export const RolesIcon = Shield;
export const AdminIcon = UserCog;
export const KeyUserIcon = UserStar;
export const VipIcon = UserStar;
export const SettingsIcon = Settings;
export const NotificationsIcon = Bell;
export const MutedIcon = BellOff;
export const PinnedIcon = Pin;
export const FormTemplateIcon = LayoutTemplate;
export const ReplyTemplateIcon = MessageSquareText;
export const AttachmentIcon = Paperclip;
export const AiIcon = Sparkles;
export const UncategorizedIcon = CircleHelp;


export const AssigneeIcon = UserCheck;
export const AssigneeRemovedIcon = UserMinus;
export const ReassignIcon = ArrowRightLeft;
export const StatusChangeIcon = RefreshCw;
export const StatusIcon = CircleDot;
export const ResolvedIcon = CheckCircle2;
export const RejectedIcon = XCircle;
export const PendingIcon = CircleDashed;
export const OverdueIcon = AlarmClock;
export const SprintStartIcon = Flag;
export const SprintCloseIcon = FlagOff;
export const AccessDeniedIcon = Lock;


export const RetryIcon = RotateCcw;
export const BackIcon = ArrowLeft;
export const UnlinkIcon = Unlink;
export const ImportIcon = Upload;
export const WorkflowIcon = GitBranch;
export const DirectoryIcon = Library;
export const ErrorReportIcon = Bug;
export const BannerIcon = MessageSquareWarning;
export const CampaignIcon = Megaphone;
export const MailboxIcon = Mailbox;
export const ReleaseIcon = Newspaper;
export const ReleasePoolIcon = Layers;
export const WikiSectionIcon = BookOpen;
export const SystemStatusIcon = Activity;


export const EVENT_ICONS: Record<string, LucideIcon> = {
  system_status: SystemStatusIcon,
  ticket_created: Plus,
  ticket_created_vip: VipIcon,
  ticket_viewed: Eye,
  ticket_rated: RatingIcon,
  message_sent: ChatIcon,
  message_edited: Pencil,
  message_deleted: Trash2,
  mentioned: AtSign,
  status_changed: StatusChangeIcon,
  participant_added: UserPlus,
  participant_removed: UserMinus,
  assignee_added: AssigneeIcon,
  assignee_removed: AssigneeRemovedIcon,
  assignee_reassigned: ReassignIcon,
  group_assigned: GroupIcon,
  group_reassigned: ReassignIcon,
  approval_created: ApprovalIcon,
  approval_approved: ResolvedIcon,
  approval_rejected: RejectedIcon,
  approval_removed: Trash2,
  approval_cancelled: Ban,
  approval_round_started: ApprovalIcon,
  approval_round_approved: ResolvedIcon,
  approval_round_rejected: RejectedIcon,
  approval_round_removed: Trash2,
  approval_level_reminded: NotificationsIcon,
  template_applied: ReplyTemplateIcon,
  mass_incident_marked: MassIncidentIcon,
  mass_incident_unmarked: ShieldCheck,
  workflow_notify: NotificationsIcon,
  workflow_chain: GitBranch,
  complexity_changed: Gauge,
  reclassified: CategoryIcon,
  complexity_requested: Gauge,
  complexity_request_decided: Gauge,
  plan_changed: TaskHoursIcon,
  resolution_confirmed: ResolvedIcon,
  resolution_rejected: RejectedIcon,
  confirmation_reminded: NotificationsIcon,
  folder_grant_expired: FolderGrantIcon,
  task_assigned: AssigneeIcon,
  task_reopened: StatusChangeIcon,
  task_commented: ChatIcon,
  task_mentioned: AtSign,
  sprint_started: SprintStartIcon,
  sprint_closed: SprintCloseIcon,
  sprint_overdue: OverdueIcon,
  chat_mentioned: AtSign,
  chat_message: MessengerIcon,

  task_created: Plus,
  assignees_changed: AssigneeIcon,
  sprint_changed: SprintIcon,
  sprint_carried: CarryOverIcon,
  estimate_changed: TaskHoursIcon,
  spent_manual_changed: TaskHoursIcon,
  plan_start_changed: PlanPinIcon,
  plan_end_changed: PlanPinIcon,
  title_changed: Pencil,
  description_changed: Pencil,
  priority_changed: TaskPriorityIcon,
  due_changed: DateIcon,
  labels_changed: TaskLabelIcon,
  triaged: Check,
  parent_changed: TaskLinkIcon,
  link_added: TaskLinkIcon,
  link_removed: UnlinkIcon,
  ticket_linked: TaskLinkIcon,
  ticket_unlinked: UnlinkIcon,
  ticket_finished: TicketIcon,
  commented: ChatIcon,
  comment_deleted: Trash2,
  attachment_added: AttachmentIcon,
  attachment_removed: Trash2,
  sprint_created: SprintIcon,
  sprint_committed: PlanFrozenIcon,
  sprint_uncommitted: PlanOpenIcon,
  sprint_deleted: Trash2,
  capacity_changed: CapacityIcon,
  message_moved: ReassignIcon,
  email_sent: EmailIcon,
};
